import { NgModule, Injectable } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ZittingArchiefComponent } from './zitting-archief/zitting-archief.component';
import { RouterModule, Routes } from '@angular/router';
import { ArchiefService } from './archief.service';
import { SharedModule } from '../shared/shared.module';
import { FormsModule } from '@angular/forms';

export const archiefRoutes: Routes =[
    { path: 'zittingarchief', component: ZittingArchiefComponent }
]

// @NgModule({
//     imports: [
//         CommonModule,
//         FormsModule,
//         SharedModule,
//         RouterModule.forChild([
//             { path: 'zittingarchief', component: ZittingArchiefComponent }
//         ]),
//         ZittingArchiefComponent
//     ],
//     providers: [ArchiefService]
// })
// export class ArchiefModule { }
